import React, { useEffect, useState, useRef } from 'react';
import { useMsal } from '@azure/msal-react';
import { Box, CircularProgress, Typography } from '@mui/material';

const MsalProviderWrapper = ({ children }) => {
  const { instance, inProgress } = useMsal();
  const [isInitialized, setIsInitialized] = useState(false);
  const [redirectHandled, setRedirectHandled] = useState(false);
  const initializationStarted = useRef(false);

  useEffect(() => {
    const initializeMsal = async () => {
      if (initializationStarted.current) {
        return; // Prevent multiple initializations
      }
      
      initializationStarted.current = true;
      
      try {
        console.log('Initializing MSAL...');
        await instance.initialize();
        console.log('MSAL initialized successfully');
        
        // Handle redirect result after initialization
        console.log('Handling redirect promise...');
        const response = await instance.handleRedirectPromise();
        if (response) {
          console.log('Login successful:', response);
          console.log('Account:', response.account);
          console.log('Access token:', response.accessToken ? 'Present' : 'Missing');
        } else {
          console.log('No redirect response - user may not have been redirected from login');
        }
        
        // Add a small delay to allow MSAL to update accounts
        await new Promise(resolve => setTimeout(resolve, 500));
        
        setRedirectHandled(true);
        setIsInitialized(true);
      } catch (error) {
        console.error('MSAL initialization failed:', error);
        setRedirectHandled(true);
        setIsInitialized(true); // Set to true even on error to prevent infinite loading
      }
    };

    initializeMsal();
  }, [instance]);

  // Show loading while MSAL is initializing or handling redirect
  if (!isInitialized || !redirectHandled || inProgress === 'login' || inProgress === 'acquireToken' || inProgress === 'handleRedirect') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        }}
      >
        <CircularProgress size={60} sx={{ color: '#1976d2', mb: 3 }} />
        <Typography variant="h6" sx={{ color: '#1a365d', fontWeight: 600 }}>
          {!isInitialized ? 'Initializing authentication...' : 'Authenticating...'}
        </Typography>
      </Box>
    );
  }

  return children;
};

export default MsalProviderWrapper;
